/**
 * Whether a string looks like one email address — the check the UX's forms use.
 *
 * Its own module, with no imports, so code that must stay free of the page's dependencies (the
 * Hubby core: no notistack, no React) can use it. `util/Functions` re-exports it, so page code
 * keeps importing it from there.
 */
export function isValidEmail(email: string): boolean {
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
